import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Buildings, FileText, ShoppingCart, Truck, ChartPie, BookOpen } from '@phosphor-icons/react';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import ProjectsPage from './ProjectsPage';
import InvoicingPage from './InvoicingPage';
import ShoppingListPage from './ShoppingListPage';
import VerticalTabs from '../components/VerticalTabs';
import { OrdersTab } from '../components/site/OrdersTab';
import StatsPage from './StatsPage';
import LibraryAndCatalogPage from './LibraryAndCatalogPage';

const SiteManagementPage = () => {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  const [searchParams, setSearchParams] = useSearchParams();
  const urlTab = searchParams.get('tab');
  // Redirect legacy tabs:
  // - 'archives' / 'project_docs' -> 'chantiers'
  // - 'catalogue' / 'bibliotheque' -> 'bibliotheque_catalogue' (merged tab)
  const resolveTab = (t) => {
    if (t === 'archives' || t === 'project_docs') return 'chantiers';
    if (t === 'catalogue' || t === 'bibliotheque') return 'bibliotheque_catalogue';
    return t;
  };
  const initialTab = urlTab ? resolveTab(urlTab) : (isAdmin ? 'chantiers' : 'courses');
  const [mainTab, setMainTab] = useState(initialTab);
  const { t } = useLanguage();
  useEffect(() => {
    if (!urlTab) return;
    const resolved = resolveTab(urlTab);
    if (resolved !== mainTab) setMainTab(resolved);
  }, [urlTab, mainTab]);
  const handleTabChange = (v) => { setMainTab(v); setSearchParams({ tab: v }, { replace: true }); };

  const TABS = isAdmin
    ? [
        { key: 'chantiers', label: t('tab.projects_list'), icon: Buildings },
        { key: 'facturation', label: t('tab.invoicing'), icon: FileText },
        { key: 'courses', label: t('tab.shopping'), icon: ShoppingCart },
        { key: 'commandes', label: t('tab.orders'), icon: Truck },
        { key: 'statistiques', label: 'Statistiques', icon: ChartPie },
        { key: 'bibliotheque_catalogue', label: 'Bibliothèque & Catalogue', icon: BookOpen },
      ]
    : [
        { key: 'courses', label: t('tab.shopping'), icon: ShoppingCart },
      ];

  return (
    <div data-testid="site-management-page">
      <div className="page-header">
        <h1 className="page-title">{isAdmin ? t('page.projects') : t('nav.my_projects')}</h1>
        <p className="page-subtitle">{isAdmin ? t('page.projects_sub') : ''}</p>
      </div>

      <VerticalTabs tabs={TABS} activeTab={mainTab} onTabChange={handleTabChange}>
        {mainTab === 'chantiers' && <ProjectsPage embedded />}
        {mainTab === 'facturation' && <InvoicingPage embedded />}
        {mainTab === 'courses' && <ShoppingListPage embedded />}
        {mainTab === 'commandes' && <OrdersTab />}
        {mainTab === 'statistiques' && <StatsPage />}
        {mainTab === 'bibliotheque_catalogue' && isAdmin && <LibraryAndCatalogPage />}
      </VerticalTabs>
    </div>
  );
};

export default SiteManagementPage;
